// @flow

var controllerConfigured = false;

function getController() : Object {
  if (!controllerConfigured) {
    if (window.vr_controller && window.vr_controller.configure) {
      window.vr_controller.configure("vr/", "vr/");
      controllerConfigured = true;
    }
  }
  return window.vr_controller;
}

function getBGIndexFromOptionCode(code: string): number {
  // b01:별 빛 하늘 -> 1, b02:하이웨이 -> 2, b03: 도시 야경 -> 0
  if (code === "b02") {
    return 2;
  }
  else if (code === "b03") {
    return 0;
  }
  else if (code === "b01") {
    return 1;
  }
  return 0;
}

export function loadModel(code: string, options: Object, optionCodes: Object) {
  console.log("loadModel:code=", code, "options:", options);
  let controller = getController();
  //let color_code = options.color;
  function loadAction () {
    controller.load("torres", function(){
      controller.effect.fadeIn();
      controller.color.load(0);//TODO : Chloe please check the color index. (now the color is )
      //controller.actions.execute("intro camera off");
      setTimeout(function(){
        controller.effect.showIntro();
      }, 2000);
      
    }, {backgroundIndex:getBGIndexFromOptionCode(optionCodes.bg)} );
  }

  if (controller != null) {
    if (controller.load) {
      loadAction();
    }
    else {
      //console.log('controller.load is undefined.');
      setTimeout(loadAction, 500);
    }
  } else {
    window.addEventListener("__vr_loaded", loadAction);
  }
}

var seat_indices = [0, 1, 2, 3];//CHECKME

export function showExterior(options : Object) {
  let controller = getController();
  if (controller === undefined) return;
  //console.log("showExterior");
  //controller.actions.execute("intro camera off");
  controller.actions.execute("exterior 0");
}

export function showInterior(options : Object) {
  let controller = getController();
  if (controller === undefined) return;

  //console.log("options:", options);
  var execute_command = "interior"+options.position + " "+seat_indices[options.seat] ;
  //console.log("execute:"+execute_command);
  //controller.actions.execute("intro camera off");
  controller.actions.execute(execute_command);
  //enableWheelCamera(false);
  controller.actions.execute("wheel camera off");
}

// export function showMoodLamp(flag:boolean, ambient:number) {
//   let controller = getController();
//   if (controller === null) return;
//   controller.moodlamp.setEnabled(true);
//   console.log("setHue:ambient=", ambient);
//   controller.moodlamp.setHue(ambient || 0);

// }

export function applyOptionCode(option: string, code: string | number | boolean, index : number, options : Object) {
  // ex {option: color, code: abp}
  if (process.env.NODE_ENV !== "production") {
    console.log("applyOptionCode:option=", option, "code:", code, "index:", index, "options:", options);
  }
  
  let controller = getController();
  if (controller === undefined) return;

  function applySunroof(options: Object) {
    
    let disableSunroof = false;
    //options
    if (options.o03 || options.o04 || options.color >= 7 ) {
      disableSunroof = true;
    }

    if (disableSunroof === false) {
      controller.customization.load("sunroof", 1);
    } else {
      controller.customization.load("sunroof", 0);
    }

  }

  if (option === "color") {
    controller.color.load(index);
    applySunroof(options);
  }
  else if (option === "wheel") {
    controller.wheel.load(index);
  }
  else if (option === "bg") {
    if (typeof code == "string") {
      controller.background.load(getBGIndexFromOptionCode(code));
    }
  }
  else if (option === "lamp") {
    controller.lamp.setEnabled(code);
  }
  else if (option === "signal_lamp") {
    console.log("playToggle:", code);
    controller.lamp.playToggle(code, "signal");
  }
  else if (option === "option") {
    //skip
  }
  else if (option === "o01") {
    controller.customization.load("sidestep", code ? 1 : 0);
  }
  else if (option === "o02") {
    controller.customization.load("storagebox", code ? 1 : 0);
  }
  else if (option === "o03") {
    // ?
    controller.customization.load("roof", code ? 2 : 0);
    applySunroof(options);
  }
  else if (option === "o04") {
    controller.customization.load("roof", code ? 1 : 0);
    applySunroof(options);
  }
  else if (option === "door") {
    if (code)
      controller.door.openAll();
    else
      controller.door.closeAll();
  }
  else if (option === "seat") {

    //controller.interior.load(seat_indices[options.seat], options.position);
    //var execute_command = "interior"+options.position + " "+seat_indices[options.seat] ;
    //console.log("execute:"+execute_command);
    //options.position + 
    const execute_command = "exterior seat"+seat_indices[options.seat] ;
    controller.actions.execute(execute_command);
  }
  else if (option === "position") {
    controller.interior.load(seat_indices[options.seat], options.position);
    const execute_command = "interior"+options.position + " "+seat_indices[options.seat] ;
    controller.actions.execute(execute_command);
    console.log("execute:"+execute_command);
  }
  else if (option === "ambient") {
    controller.moodlamp.setHue(code);
  }
  else if (option === "ambientOn") {
    //console.log("ambientOn:options=", options);
    controller.moodlamp.setHue(options.ambient);
    controller.moodlamp.setEnabled(code);
  }


}

// car:lamp
// car:door
export function addVREventListener(key: string, callback: (...args: Array<any>) => void, thisObject : any ) {
  let controller = getController();
  if (controller != null && controller.addEventListener) {
    controller.addEventListener(key, callback);
  } else {
    window.addEventListener("__vr_loaded", () => controller.addEventListener(key, callback));
  }
}

export function removeVREventListener(key: string, callback: (...args: Array<any>) => void, thisObject : any) {
  let controller = getController();
  if (controller != null && controller.removeEventListener) {
    controller.removeEventListener(key, callback);
  } else {
    window.addEventListener("__vr_loaded", () => controller.removeEventListener(key, callback));
  }
}

export function enableSpots(flag:boolean) {
  //console.warn("enableSpots:flag=" ,flag)
  let controller = getController();
  if (controller === undefined) {
    return;
  }
  controller.spot.setEnabled(flag);
  //controller.spot.setSelected(1);
}

export function enableWheelCamera(flag:boolean) {
  let controller = getController();
  if (controller === undefined) {
    return;
  }
  controller.door.closeAll(null, true);
  controller.actions.execute(flag ? "wheel camera on" : "wheel camera off");
}

export function triggerColorCamera() {
  let controller = getController();
  if (controller === undefined) {
    return;
  }
  console.log("triggerColorCamera");
  controller.effect.triggerColor();
}

export function triggerSeatCamera() {
  let controller = getController();
  if (controller === undefined) {
    return;
  }
  console.log("triggerSeatCamera");
  controller.effect.triggerSeat();
}

export function triggerCustomizationCamera() {
  let controller = getController();
  if (controller === undefined) {
    return;
  }
  console.log("triggerCustomizationCamera");
  controller.effect.triggerCustomization();
}
export function triggerMoodlampCamera() {
  let controller = getController();
  if (controller === undefined) {
    return;
  }
  console.log("triggerMoodlampCamera");
  controller.effect.triggerMoodlamp();
}


export function selectSpots(key:string) {
  let controller = getController();
  if (controller === undefined) {
    return;
  }
  controller.spot.setSelected(key);
}

export function resizeVR(width:number, height:number) {
  let controller = getController();
  if (controller === undefined) {
    return;
  }
  console.log("resizeVR:width=", width, "height=", height);

  controller.setSize(width, height);
}
